(function ($) {
    $(document).ready(function () {
        let postsPerLoad = 3;
        let currentVenue = 'ANY';
        let currentPage = 1;
        let maxPages = 1;

        // Initialize select2
        $('#venue-dropdown').select2({
            placeholder: 'Select a Venue',
            minimumResultsForSearch: Infinity,
            dropdownAutoWidth: true,
            theme: "flat",
            width: '100%', 
        });

        // Event listener for venue selection change
        $('#venue-dropdown').on('change', function (e) {
            e.preventDefault();
            currentVenue = $(this).val();
            currentPage = 1;
            loadPostsByVenue(currentVenue, 1);
        });

        // Load more button click handler
        $('#load-more-gallery-btn').on('click', function() {
            currentPage++;
            loadPostsByVenue(currentVenue, currentPage);
        });

        function loadPostsByVenue(venueId, page) {
            let restUrl = '/wp-json/wp/v2/gallery';
            let params = {
                _embed: true,
                per_page: postsPerLoad,
                page: page
            };

            if (venueId !== 'ANY') {
                params.venue = venueId;
            }

            console.log('Loading page', page, 'for venue:', venueId);

            if (page === 1) {
                $('.articles-grid').empty();
                $('#load-more-gallery-btn').hide();
            }

            $.ajax({
                url: restUrl,
                method: 'GET',
                data: params,
                beforeSend: function (xhr) {
                    if (page > 1) {
                        $('#load-more-gallery-btn').addClass('rest-running');
                        $('#load-more-gallery-btn .wp-block-button__link').addClass('loading');
                        $('#load-more-gallery-btn .wp-block-button__text').html('LOADING <mark style="background-color:rgba(0, 0, 0, 0)" class="has-inline-color has-green-color"><img decoding="async" class="wp-image-794" style="width: NaNpx;" src="https://cornerstone.tt5.studiothink.com/wp-content/uploads/2024/09/PLUS-ICON.svg" alt=""></mark>');
                    }
                }
            }).done(function (data, textStatus, jqXHR) {
                maxPages = parseInt(jqXHR.getResponseHeader('x-wp-totalpages')) || 1;
                
                console.log('Loaded page', page, 'of', maxPages, '- got', data.length, 'items');
                
                data.forEach(function (postData) {
                    let content = createGalleryContent(postData);
                    $('.articles-grid').append(content);
                });
                
                if (page < maxPages) {
                    $('#load-more-gallery-btn').show();
                    $('#load-more-gallery-btn .wp-block-button__text').html('LOAD MORE <mark style="background-color:rgba(0, 0, 0, 0)" class="has-inline-color has-green-color"><img decoding="async" class="wp-image-794" style="width: NaNpx;" src="https://cornerstone.tt5.studiothink.com/wp-content/uploads/2024/09/PLUS-ICON.svg" alt=""></mark>');
                } else {
                    $('#load-more-gallery-btn').hide();
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.error('AJAX Request Failed:', errorThrown);
                if (page > 1) {
                    currentPage--;
                }
                $('#load-more-gallery-btn').hide();
            }).always(function() {
                $('#load-more-gallery-btn').removeClass('rest-running');
                $('#load-more-gallery-btn .wp-block-button__link').removeClass('loading');
            });
        }

        function createGalleryContent(postData) {
            let featuredImage = postData._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
            
            let galleryImages = postData._embedded?.['acf:attachment'] || [];
            let photographer = postData.acf?.photographer || { title: '', url: '' };
            
            let galleryId = 'lity-' + postData.id;
            let splideId = 'splide-' + postData.id;
            
            let gallerySlides = '';
            galleryImages.forEach(function(image) {
                let imageUrl = image.source_url || image.link || '';
                let imageAlt = image.alt_text || image.title?.rendered || '';
                
                gallerySlides += `
                    <li class="splide__slide">
                        <figure class="splide__image-wrapper">
                            <img data-splide-lazy="${imageUrl}" 
                                 alt="${imageAlt.replace(/"/g, '&quot;')}" />
                        </figure>
                    </li>
                `;
            });

            let article = document.createElement('li');
            article.classList.add('wp-block-post', 'gallery', 'type-gallery', 'status-publish', 'has-post-thumbnail', 'post-' + postData.id);
            article.id = 'post-' + postData.id;

            let mainHTML = `
                <a class="wp-block-st-post-card" href="#${galleryId}" data-lity>
                    <div class="acf-innerblocks-container">
                        <figure class="article-img wp-block-post-featured-image">
                            <img loading="lazy" decoding="async" width="782" height="782" 
                                 src="${featuredImage}" 
                                 class="attachment-post-thumbnail size-post-thumbnail wp-post-image" 
                                 alt="${(postData.title?.rendered || '').replace(/"/g, '&quot;')}" 
                                 style="object-fit:cover;">
                        </figure>
                        <hr class="wp-block-separator has-text-color has-taupe-color has-alpha-channel-opacity has-taupe-background-color has-background is-style-wide is-full-divider">
                        <div class="wp-block-group article-details is-vertical is-layout-flex wp-container-core-group-is-layout-16 wp-block-group-is-layout-flex">
                            <h5 style="font-style:normal;font-weight:400;" class="has-link-color is-article-title wp-block-post-title has-text-color has-brown-color has-p-font-size has-utile-display-font-family">
                                ${postData.title?.rendered || ''}
                            </h5>
                        </div>
                    </div>
                </a>
            `;

            let galleryHTML = `
                <div class="gallery-content lity-hide" id="${galleryId}" data-post-id="${postData.id}">
                    <div class="gallery-modal">
                        <div class="gallery-modal__inner">
                            <section class="splide gallery-splide" id="${splideId}">
                                <div class="splide__track">
                                    <ul class="splide__list">
                                        ${gallerySlides}
                                    </ul>
                                </div>
                                <div class="gallery-info">
                                    <div>
                                        <h5 class="gallery-name">${postData.title?.rendered || ''}</h5>
                                    </div>
                                    ${photographer.title ? `
                                        <div class="gallery-photographer">
                                            Photographer:                                             
                                            <a ${photographer.url ? 'href="' + photographer.url + '" target="_blank"' : ''} class="photographer-name">
                                                ${photographer.title}
                                            </a>
                                        </div>
                                    ` : ''}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            `;

            article.innerHTML = mainHTML + galleryHTML;
            return article;
        }
    });
})(jQuery);

// Single initialization for Splide modals
(function($) {
    if (typeof window.stGalleryModalInitialized === 'undefined') {
        window.stGalleryModalInitialized = true;
        
        $(document).on('lity:open', function(event, instance) {
            // FIX: Add comprehensive null checks
            var $opener = instance.opener();
            if (!$opener || !$opener.length) {
              //  console.warn('No opener element found');
                return;
            }
            
            var href = $opener.attr('href');
            if (!href || typeof href !== 'string') {
             //   console.warn('No valid href attribute found on opener');
                return;
            }
            
            var targetId = href.replace('#', '');
            var $target = $('#' + targetId);
            
            if (!$target.length) return;
            
            var $splideElement = $target.find('.gallery-splide');
            var postId = $target.data('post-id');
            
            if ($splideElement.length && !$splideElement.hasClass('splide-initialized')) {
                
                $.ajax({
                    url: '/wp-json/wp/v2/media?parent=' + postId,
                    method: 'GET',
                    success: function(mediaItems) {
                        var imageMap = {};
                        mediaItems.forEach(function(item) {
                            imageMap[item.id] = item.source_url || item.link;
                        });
                        
                        $splideElement.find('.splide__slide').each(function() {
                            var $slide = $(this);
                            var imageId = $slide.data('image-id');
                            var imageUrl = imageMap[imageId];
                            
                            if (imageUrl) {
                                var $img = $slide.find('img');
                                $img.attr('data-splide-lazy', imageUrl);
                                $img.attr('alt', 'Gallery image ' + imageId);
                            }
                        });
                        
                        setTimeout(function() {
                            try {
                                if (typeof Splide === 'undefined') {
                                    console.error('Splide not loaded');
                                    return;
                                }
                                
                                var splide = new Splide($splideElement[0], {
                                    type: 'fade',
                                    rewind: true,
                                    lazyLoad: 'nearby',
                                    preloadPages: 2,
                                    pagination: false,
                                    arrows: true,
                                    arrowPath: 'M19.1164 0.395413C18.9194 0.200021 18.6217 0.211981 18.4514 0.422128C18.2812 0.632275 18.3028 0.961028 18.4998 1.15642L36.639 19.1485H0.94873C0.672588 19.1485 0.44873 19.3723 0.44873 19.6485C0.44873 19.9246 0.672588 20.1485 0.94873 20.1485H36.7747C37.0106 20.1485 37.2084 19.9851 37.261 19.7653L37.3427 19.8464L19.1549 38.9629C18.97 39.1573 18.9686 39.486 19.1518 39.697C19.3351 39.9081 19.6336 39.9216 19.8186 39.7271L38.3682 20.2303L38.7301 19.85L38.3447 19.4677L19.1164 0.395413Z'
                                });
                                splide.mount();
                                $splideElement.addClass('splide-initialized');
                                console.log('Splide Slider - initialized for:', targetId);
                            } catch (e) {
                                console.error('Splide initialization error:', e);
                            }
                        }, 200);
                    },
                    error: function() {
                        console.error('Failed to fetch media for post:', postId);
                    }
                });
            }
        });
    }
})(jQuery);